import React from 'react';
import { Radio } from '@atlaskit/radio';
import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';
import { Text } from '@atlaskit/primitives';
import { CloudSiteInfo } from './add-new-products-modal';
import { NewCloudSiteLozenge } from '../../../product-line-items/src/components/product-line-item';
import { NEW_CLOUD_SITE_ID, NEW_CLOUD_SITE } from '../../../../constants';

interface CloudSitesListProps {
  cloudSitesList: CloudSiteInfo[];
  selectedCloudSite: CloudSiteInfo | undefined | null;
  setSelectedCloudSite: (data: CloudSiteInfo) => void;
}

const ListWrapper = styled.div`
  display: flex;
  border: 1px solid ${token('color.border')};
  border-radius: ${token('space.100')};
  gap: ${token('space.100')};
  padding: ${token('space.150')};
  align-items: center;
  &:hover {
    background-color: ${token('elevation.surface.hovered')};
  }
  cursor: pointer;
`;

const CloudSitesListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 474px;
  overflow-y: overlay;
  margin-right: -15px;
  padding-right: 15px;
`;

export const CloudSitesList = ({ cloudSitesList, selectedCloudSite, setSelectedCloudSite }: CloudSitesListProps) => {
  cloudSitesList.unshift({ cloudSiteId: NEW_CLOUD_SITE_ID, cloudSiteHostName: NEW_CLOUD_SITE });
  const handleSelectedItem = (cloudsite: CloudSiteInfo) => {
    setSelectedCloudSite(cloudsite);
  };
  return (
    <CloudSitesListWrapper>
      {cloudSitesList.map((cloudsite) => (
        <ListWrapper key={cloudsite.cloudSiteId} onClick={() => handleSelectedItem(cloudsite)}>
          <Radio
            isChecked={selectedCloudSite?.cloudSiteId === cloudsite.cloudSiteId}
            onChange={() => handleSelectedItem(cloudsite)}
            name={cloudsite.cloudSiteHostName}
            value={cloudsite.cloudSiteHostName}
          />
          {cloudsite.cloudSiteId === NEW_CLOUD_SITE_ID ? (
            <NewCloudSiteLozenge />
          ) : (
            <Text weight="semibold" color="color.text">
              {cloudsite.cloudSiteHostName}
            </Text>
          )}
        </ListWrapper>
      ))}
    </CloudSitesListWrapper>
  );
};
